export enum OrderStatusIds {
  IN_PRE_ORDER = 0,
  NEW = 1,
  DELIVERED = 3,
  CANCELLED = 5,
  LOST = 6,
  READY_TO_PICKUP = 11,
  ASSIGNED_TO_JOB = 12,
  IN_PICKUP_TASK = 21,
  OUT_FOR_DELIVERY = 22,
  OUT_FOR_RETRUN = 23,
  COMPLETED_WITH_RETURN_POLICY = 31,
  DELIVERING = 221,
  RETURNED_TO_MERCHANT = 231,
  FAILED_TO_PICKUP_FROM_COMPANY = 411,
  FAILED_TO_PICKUP_FROM_BOUNTY_DRIVER = 412,
  FAILED_TO_PICKUP_FROM_CUSTOMER = 413,
  FAILED_DELIVERY_TO_COMPANY = 421,
  FAILED_DELIVERY_TO_DRIVER = 422,
  FAILED_DELIVERY_TO_CUSTOMER = 423,
  FORCE_CANCELLED = 501,
  FORCE_CANCELLED_PICKUP = 502,
  FORCE_CANCELLED_DELIVERY = 503,
}

export enum OrderTypeIds {
  EXPRESS = 1,
  NORMAL = 2,
  BULK = 3,
  SUBSCRIPTION = 4,
  VIRTUAL_STORE = 5,
  COUTURE_DELIVERY = 6,
  FULFILMENT_ORDER = 7,
}
